import { render, staticRenderFns } from "./comtotalStyle.vue?vue&type=template&id=35d69526&scoped=true&"
import script from "./comtotalStyle.vue?vue&type=script&lang=js&"
export * from "./comtotalStyle.vue?vue&type=script&lang=js&"
import style0 from "./comtotalStyle.vue?vue&type=style&index=0&id=35d69526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d69526",
  null
  
)

export default component.exports